import { useContext } from 'react';

import SearchResultsContext from '../utils/SearchResultsContext';

export default function useSearchResultsContext() {
  return useContext(SearchResultsContext);
}
